import api from './api';

export const getComments   = (courseId, lessonId) => api.get(`/courses/${courseId}/lessons/${lessonId}/comments`).then(r => r.data.comments);
export const createComment = (courseId, lessonId, body, parentCommentId, image_url) => api.post(`/courses/${courseId}/lessons/${lessonId}/comments`, { body, parentCommentId, image_url }).then(r => r.data.comment);
export const deleteOwnComment = (commentId) => api.delete(`/courses/lessons/comments/${commentId}`);
